{
  "addKey": "Schlüssel hinzufügen",
  "api": {
    "anthropic": "Anthropic",
    "gemini": "Gemini (nur abgerechnetes Cloud-Projekt)",
    "openai": "OpenAI",
    "openai_compatible": "OpenAI-kompatibel (etwa KISSKI)"
  },
  "apiKey": "API-Schlüssel",
  "baseUrl": "Basis-URL",
  "budgetCalls": "Aufrufe",
  "budgetHelp": "Je Kalendermonat (UTC), von DMW gezählt. Ein leeres Feld heißt: keine Grenze. Die Grenzen des Anbieters gelten zusätzlich.",
  "budgetTokens": "Tokens",
  "callsOfLimit_one": "{{used}} von {{count}} Aufruf",
  "callsOfLimit_other": "{{used}} von {{count}} Aufrufen",
  "callsUsed_one": "{{count}} Aufruf",
  "callsUsed_other": "{{count}} Aufrufe",
  "changeBudget": "Budget ändern",
  "geminiBilledOnly": "Nutzen Sie einen Schlüssel eines Cloud-Projekts mit Abrechnung. Kostenlose Schlüssel dürfen nicht anderen dienen; sie gehören in den eigenen DMW Connector einer Person.",
  "hostOffline": "DMW-Server offline",
  "hostOnline": "DMW-Server online",
  "hostsHint": "Gruppe unter Administration → Installation freigeben, dann unter Projekteinstellungen → Regeln zulassen.",
  "hostsTitle": "DMW-Server",
  "intro": "Schlüssel werden verschlüsselt und nur beim Eingeben angezeigt.",
  "keyDetails": "…{{hint}} · {{models}} · hinzugefügt {{time}}",
  "keyHelp": "Der Server prüft den Schlüssel beim Anbieter, bevor er ihn speichert. Ein Widerruf hier widerruft ihn nicht beim Anbieter.",
  "keysTitle": "Schlüssel",
  "llmCount_one": "{{count}} LLM",
  "llmCount_other": "{{count}} LLMs",
  "noHosts": "Noch darf niemand die Schlüssel des Servers nutzen.",
  "noKeys": "Noch keine Schlüssel.",
  "offBody": "Serverschlüssel sind aus: {{reason}}. Die Betreiber setzen die Datei des Schlüsselverschlüsselungsschlüssels und den GTA-Befehl in der Serverkonfiguration.",
  "offTitle": "Serverschlüssel sind aus",
  "pairedAt": "seit {{time}}",
  "provider": "Anbieter",
  "removedAccount": "Entferntes Konto",
  "revokeKey": "Widerrufen",
  "revokeKeyConfirm": "Diesen Schlüssel widerrufen? Die gespeicherte Kopie wird sofort gelöscht. Widerrufen Sie ihn auch beim Anbieter.",
  "revoked": "Widerrufen",
  "routeName": "Routenname",
  "routeNameHelp": "Geben Sie einen Namen ein, etwa Anthropic Server. Leerzeichen werden zu Bindestrichen.",
  "routeNameInvalid": "Beginne den Namen mit einem Buchstaben (A–Z) oder einer Ziffer (0–9).",
  "routeNameSavedAs": "Wird gespeichert als: {{routeId}}",
  "saveBudget": "Budget speichern",
  "spend": {
    "limit": "Monatsgrenze: {{amount}}",
    "limitNotRead": "Grenze nicht gelesen: {{reason}}",
    "limitStated": "Monatsgrenze: {{amount}} (wie in der Konsole des Anbieters gesetzt)",
    "noLimit": "Keine Monatsgrenze bekannt",
    "none": "Nicht eingerichtet. Um die Ausgaben und Grenzen der Anbieter hier zu sehen, geben Sie dem Server eine Datei mit einem Admin-Schlüssel (Hilfe: Serverschlüssel).",
    "notRead": "Ausgaben nicht gelesen: {{reason}}",
    "organization": "Organisation",
    "readAt": "gelesen {{time}}",
    "spent": "{{month}}: {{amount}} ausgegeben",
    "title": "Ausgaben bei den Anbietern"
  },
  "title": "Serverschlüssel",
  "tokensOfLimit_one": "{{used}} von {{count}} Token",
  "tokensOfLimit_other": "{{used}} von {{count}} Tokens",
  "tokensUsed_one": "{{count}} Token",
  "tokensUsed_other": "{{count}} Tokens",
  "usage": "{{period}}: {{calls}}, {{tokens}}"
}
